<template>
  <div class="pc_scroll-tab" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
    <!-- 头部导航 -->
    <ul class="activity-rule-nav" :class="{ 'show-all': isExpanded }">
      <li
        v-for="(item, index) in list"
        :key="index"
        :class="[
          index == active || (item.brandId && activeId && activeId == item.brandId)
            ? 'active'
            : ''
        ]"
        @click="handleSetActive(item, index, $event)"
      >
        {{ item.tabName || item.name || item.categoryName || item.brandName }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'PCScrollTab2',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    active: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: ''
    },
    // 默认是品牌id
    activeId: {
      type: Number || String,
      default: null
    },
    // 默认选中的id
    id: {
      type: Number || String,
      default: null
    }
  },
  data() {
    return {
      sortList: [],
      tabId: null,
      isExpanded: false // 控制是否展开
    };
  },
  methods: {
    handleSetActive(item, index, event) {
      const data = {
        ...item,
        index
      };
      this.$emit('handleSetActive', data);

    },
    handleNoData(data) {
      setTimeout(() => {
        this.$emit('handleNoData', data);
      }, 100);
    },
    initResponse(data) {
      const sortList = [];
      data.forEach((val, index) => {
        if (val.body && val.body.textList) {
          data[index].body.textList = val.body.textList.map((sub, num) => {
            sub.body = sub.body.split('\n');
            return sub;
          });
        }
        // 重排序
        const arr = new Array(3);
        for (const key in val) {
          if (Object.prototype.toString.call(val[key]) === '[object Object]') {
            arr[parseInt(val[key].sort)] = val[key];
          }
        }
        sortList.push(arr);
      });
      // 已按 sort 排序
      this.sortList = sortList;
      this.$emit('update:list', data);
      // this.list = []
    },
    // 点击品牌后，根据品牌id查询获取品牌的产品列表
    queryProductById(id) {
      if (id) {
        id = parseInt(id);
        let num = 0;
        this.list.map(item => {
          if (item.brandId === id) {
            num++;
          }
        });
        if (num === 1) {
          // this.active = id
          this.$store.dispatch('productListScrollToStartPosition', id);
          this.$store.dispatch('queryProductList', { brandId: id });
        } else if (this.list && this.list[0] && this.list[0].brandId) {
          // this.active = this.list[0].brandId
          this.$store.dispatch('productListScrollToStartPosition', this.list[0].brandId);
          this.$store.dispatch('queryProductList', { brandId: this.list[0].brandId });
        }
      }
    },
    handleMouseEnter() {
      this.isExpanded = true; // 鼠标移入时展开
    },
    handleMouseLeave() {
      this.isExpanded = false; // 鼠标移出时收起
    }
  }
};
</script>
<style scoped lang="less">
.pc_scroll-tab {
  // height: 100%;
  width: 100%;
  min-height: 71px;
  // overflow-x: hidden;

  .activity-rule-nav {
    display: flex;
    flex-wrap: wrap; // 允许换行
    align-items: center;
    font-size: 16px;
    cursor: pointer;
    padding: 0;
    margin: 0;
    line-height: 72px;
    max-height: 72px; // 默认只展示一行的高度
    overflow: hidden; // 隐藏超出部分
    transition: max-height 0.5s ease; // 添加过渡效果

    &.show-all {
      max-height: 500px; // 鼠标移入时展示全部内容，根据需要调整高度
    }

    .active {
      color: #ff8a14;
    }

    li {
      color: #282828;
      margin-right: 60px;
      white-space: nowrap; // 防止文字换行
      text-align: center;
      display: block;
      box-sizing: border-box;
      cursor: pointer;
      position: relative;
      font-size: 16px;
      flex-shrink: 0; // 防止 li 被压缩
    }
  }
}
</style>